import { marked } from "marked";
import { convertMultipleNewlinesToBR } from "../exports/functions";

const PrivacyPolicyInner = (props) => {
  const { policiesData } = props;
  const rawDescription = policiesData[0]?.description || "";
  const description = convertMultipleNewlinesToBR(rawDescription);
  const image = policiesData[0]?.image[0]?.media?.url || "";

  return (
    <section className="privacy-policy pt-120" id="policies">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-12">
            <div className="border border-neutral-30 rounded-12 bg-main-25 p-32 position-relative">
              <h3 className="mb-16">{policiesData[0]?.title}</h3>

              <span className="d-block border border-neutral-30 my-24 border-dashed" />

              <div
                className="policy-image-blend scale-hover-item overflow-hidden"
                style={{ pointerEvents: "auto" }}
              >
                <img
                  src={process.env.REACT_APP_cmsUrl + image}
                  alt="Admission Policy"
                  className="scale-hover-item__img w-100 h-100 d-block transition-2"
                  style={{
                    objectFit: "cover",
                    borderRadius: "0 0.75rem 0.75rem 0",
                  }}
                />
              </div>

              <div className="policy-content position-relative">
                <div
                  className="text-neutral-500 policy-text"
                  dangerouslySetInnerHTML={{
                    __html: marked(description),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicyInner;
